<template>
  <a href="javascript:void(0)" class="filter ml-3 px-3" :class="{ active: isActive }" @click="$emit('click')">
    <slot :count="count" :isLoading="isLoading" :isActive="isActive">
      {{ text }}
      <span class="badge badge-pill badge-light ml-2 font-weight-bold" v-if="isLoading || count != undefined">
        <font-awesome-icon v-if="isLoading" icon="spinner-third" spin class="text-white" />
        <template v-else>{{ count }}</template>
      </span>
    </slot>
  </a>
</template>
<script>
export default {
  props: {
    count: {
      type: [String, Number],
    },
    text: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss">
.filter {
  color: #012b30;
  padding-bottom: 0.2rem;
  font-size: 1.25em;
  font-weight: bold;
}

.badge {
  font-size: 0.85rem;
  font-weight: bold;
}

.active {
  border-bottom: 2px solid var(--primary-color);
  font-weight: bold;
  color: var(--primary-color);

  .badge {
    color: var(--primary-color);
  }
}
</style>
